module.exports = __webpack_public_path__ + "static/Dentures intraoral after-5855f8efc95c1c2c691ab3dc0bf76f76.jpg";